(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    if (root.dataset.plReady) return;
    root.dataset.plReady = '1';
    var track = root.querySelector('[data-pl-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pl-dot]'));
    var toggle = root.querySelector('[data-pl-toggle]');
    var current = 0;
    var autoplay = root.dataset.autoplay === 'true' && !reduce && slides.length > 1;

    function mark(index) {
      current = index;
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function go(index) {
      var target = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[target].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(target);
    }
    function setPlaying(value) {
      root.dataset.playing = value ? 'true' : 'false';
      if (toggle) {
        toggle.setAttribute('aria-label', value ? 'Mettre le diaporama en pause' : 'Lancer le diaporama');
        toggle.dataset.state = value ? 'playing' : 'paused';
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) mark(slides.indexOf(entry.target));
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (slide) { io.observe(slide); });
    }

    dots.forEach(function (dot) { dot.addEventListener('click', function () { go(Number(dot.dataset.plDot)); }); });
    var prev = root.querySelector('[data-pl-prev]');
    var next = root.querySelector('[data-pl-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    root.addEventListener('animationend', function (event) {
      if (event.animationName === 'pl-progress' && root.dataset.playing === 'true') go(current + 1);
    });
    root.addEventListener('mouseenter', function () { root.dataset.paused = ''; });
    root.addEventListener('mouseleave', function () { delete root.dataset.paused; });
    root.addEventListener('focusin', function () { root.dataset.paused = ''; });
    root.addEventListener('focusout', function () { delete root.dataset.paused; });
    if (toggle) toggle.addEventListener('click', function () { setPlaying(root.dataset.playing !== 'true'); });

    mark(0);
    setPlaying(autoplay);
  }

  function initRail(root) {
    if (root.dataset.plReady) return;
    root.dataset.plReady = '1';
    var track = root.querySelector('[data-pl-track]');
    var prev = root.querySelector('[data-pl-prev]');
    var next = root.querySelector('[data-pl-next]');
    if (!track) return;
    function update() {
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function step(direction) {
      track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initTabs(root) {
    if (root.dataset.plTabsReady) return;
    root.dataset.plTabsReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function select(tab) {
      tabs.forEach(function (t) {
        var active = t === tab;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.querySelectorAll('[data-pl-rail]').forEach(function (rail) {
        var track = rail.querySelector('[data-pl-track]');
        if (track) track.dispatchEvent(new Event('scroll'));
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (event) {
        var index = null;
        if (event.key === 'ArrowRight') index = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') index = (i - 1 + tabs.length) % tabs.length;
        if (index !== null) { event.preventDefault(); tabs[index].focus(); select(tabs[index]); }
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-pl-hero]').forEach(initHero);
    scope.querySelectorAll('[data-pl-rail]').forEach(initRail);
    scope.querySelectorAll('[data-pl-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();